import React, { useState } from 'react';
import { Eye, KeyRound } from 'lucide-react';
import SwitchToFullAccessModal from './SwitchToFullAccessModal';

const QuickViewBanner = ({ user }) => {
  const [showModal, setShowModal] = useState(false);
  const isQuickView = user?.session_mode === 'quick_view';
  if (!isQuickView) return null;

  return (
    <>
      <div
        data-testid="quick-view-banner"
        className="w-full bg-amber-50 border-b border-amber-200"
      >
        <div className="container mx-auto px-3 sm:px-6 py-2.5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <div className="flex items-start gap-2 text-amber-900">
            <Eye className="w-4 h-4 mt-0.5 shrink-0" />
            <p className="text-sm">
              <span className="font-semibold">You&apos;re in Quick View.</span>{' '}
              Editing is off. Sign in with your email and password to make changes.
            </p>
          </div>
          <button
            type="button"
            data-testid="switch-full-access-btn"
            onClick={() => setShowModal(true)}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-amber-900 hover:text-amber-700 underline underline-offset-2"
          >
            <KeyRound className="w-4 h-4" />
            Switch to full access →
          </button>
        </div>
      </div>
      <SwitchToFullAccessModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default QuickViewBanner;
